import { useAuth } from "../context/AuthContext.jsx";

export function usePaid() {
  const { user } = useAuth();
  return user?.plan === "paid";
}

// Wraps a premium feature. Free users see a locked explanation instead of
// the feature itself - visible, not hidden, per the brief. There is no
// working checkout yet, so the CTA is a waitlist-style note rather than a
// buy button.
export default function PremiumLock({ title, children }) {
  return (
    <div className="card" style={{ padding: "40px 24px" }}>
      <div className="kicker" style={{ marginBottom: 16 }}>
        <span className="the-line" />
        CONQUEST PREMIUM
      </div>
      <h2 style={{ marginBottom: 12, fontSize: 20 }}>{title}</h2>
      <p className="empty-state" style={{ marginBottom: 0 }}>
        {children}
      </p>
    </div>
  );
}
